import React, { useEffect } from 'react';
import { FiGift, FiX } from 'react-icons/fi';
import './trial-toast.css';

/**
 * Simple in-app toast (no extra dependencies).
 */
export default function TrialToast({ message, detail, durationMs = 9000, onClose }) {
  useEffect(() => {
    if (!durationMs) return undefined;
    const t = setTimeout(() => onClose?.(), durationMs);
    return () => clearTimeout(t);
  }, [durationMs, onClose]);

  if (!message) return null;

  return (
    <div className="trial-toast" role="status" aria-live="polite">
      <div className="trial-toast-inner">
        <span className="trial-toast-icon" aria-hidden="true"><FiGift /></span>
        <div className="trial-toast-copy">
          <strong>{message}</strong>
          {detail && <p className="trial-toast-detail">{detail}</p>}
        </div>
        <button type="button" className="trial-toast-close" onClick={() => onClose?.()} aria-label="Dismiss">
          <FiX aria-hidden="true" />
        </button>
        {durationMs > 0 && (
          <span className="trial-toast-timer" style={{ animationDuration: `${durationMs}ms` }} aria-hidden="true" />
        )}
      </div>
    </div>
  );
}
